import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAPI } from "../context/ApiContext";
import { useTranslation } from "react-i18next";

const DEFAULT_AVATAR = "/assets/images/default_profile.png";

const Appfooter = () => {
  const { profile, isAuthenticated, me, myUserId } = useAPI();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  // 先頭のimport群の下に追加（何も不要ならこのままでOK）
const scrollToTop = () => {
  const se = document.scrollingElement || document.documentElement || document.body;
  se?.scrollTo?.({ top: 0, behavior: "smooth" });

  // アプリ側で独自スクロール領域を使っている場合にも対応
  const alt = document.querySelector("[data-scroll-root], main, #root");
  alt?.scrollTo?.({ top: 0, behavior: "smooth" });
};


  // 自分のプロフィールURL
  const uid = me?.userId || myUserId || profile?.userId || "";
  const myProfileHref = isAuthenticated
    ? (uid ? `/user/${encodeURIComponent(uid)}` : "/home")
    : "/login";

  // アクティブ判定（URL更新に追随）
  const isHome       = pathname === "/home";
  const isUserSearch = pathname.startsWith("/usersearch");
  const isPageSearch = pathname.startsWith("/pagesearch") || pathname.startsWith("/owningpages"); // 互換
  const isUserPage   = /^\/user\/[^/]+/.test(pathname);

  const activeStyle = { borderBottom: "2px solid white" };

  const avatarSrc = profile?.image || DEFAULT_AVATAR;

  return (
    <div className="app-footer border-0 shadow-lg bg-primary-gradiant">
{/* Home */}
<Link
  to="/home"
  className="nav-content-bttn nav-center"
  style={isHome ? activeStyle : {}}
  aria-label={t("Header8") || "Home"}
  aria-current={isHome ? "page" : undefined}
  onClick={(e) => { if (isHome) { e.preventDefault(); scrollToTop(); } }}
>
  <i className="feather-home"></i>
</Link>

{/* User Search */}
<Link
  to="/usersearch"
  className="nav-content-bttn"
  style={isUserSearch ? activeStyle : {}}
  aria-label={t("Header9") || "Users"}
  aria-current={isUserSearch ? "page" : undefined}
  onClick={(e) => { if (isUserSearch) { e.preventDefault(); scrollToTop(); } }}
>
  <i className="feather-users"></i>
</Link>

{/* Page Search */}
<Link
  to="/postsearch"
  className="nav-content-bttn"
  style={isPageSearch ? activeStyle : {}}
  aria-label={t("Header12") || "Pages"}
  aria-current={isPageSearch ? "page" : undefined}
  onClick={(e) => { if (isPageSearch) { e.preventDefault(); scrollToTop(); } }}
>
  <i className="feather-search"></i>
</Link>

{/* My profile */}
<Link
  to={myProfileHref}
  className="nav-content-bttn"
  style={isUserPage ? activeStyle : {}}
  aria-label={t("MyPage") || "My page"}
  aria-current={isUserPage ? "page" : undefined}
  onClick={(e) => {
    if (isAuthenticated && !uid) { e.preventDefault(); return; }
    if (isUserPage) { e.preventDefault(); scrollToTop(); }
  }}
>
  <img
    src={avatarSrc}
    alt="user"
    className="w40 shadow-xss rounded-circle"
    onError={(e) => (e.currentTarget.src = DEFAULT_AVATAR)}
  />
</Link>

    </div>
  );
};

export default Appfooter;
